/**
 * Generates a combined list of pension and investment options from the given state object.
 *
 * Each option is formatted as a string in the format "name - type" and returned as an object
 * with `value` and `label` properties, suitable for use in dropdowns or selection components.
 *
 * @param {Object} state - The state object containing pension and investment arrays.
 * @param {Array<Object>} [state.pensions] - Array of pension objects, each with `name` and `type` properties.
 * @param {Array<Object>} [state.investments] - Array of investment objects, each with `name` and `type` properties.
 * @returns {Array<{value: string, label: string}>} Array of option objects for pensions and investments.
 */
const getPensionInvestmentOptions = (state) => {
  const pensionOptions = (state.pensions || [])
    .filter((p) => p.name && p.type)
    .map((p) => `${p.name.trim()} - ${p.type.trim()}`);

  const investmentOptions = (state.investments || [])
    .filter((inv) => inv.name && inv.type)
    .map((inv) => `${inv.name.trim()} - ${inv.type.trim()}`);

  return [...pensionOptions, ...investmentOptions].map((option) => ({
    value: option,
    label: option,
  }));
};

export default getPensionInvestmentOptions;
